// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","colorBlackA10":"rgba(14, 19, 24, 0.1)","list":"_1CAGCm1PzQYlXTTqWIz3cm","listItem":"_2ZyUPTL9DnLMuf5HEX1d4M _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","listItemLink":"_3yKKLCObZH7E7FU6nTBuZv","listItemButton":"_2cMoWHRQsHnwoCg07IhAG7","buttonReset":"_3FDm4JkhFDy_XnNB_QuU54 _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","listItemDivider":"cRU80PlyWyIdCs0f32Q0W","listItemTextDivider":"x-Cn4IR7BK8c_eu-kYqbg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/list/list.css
// module id = 919
// module chunks = 0